import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import styles from './accountList.module.scss';
import i18n from 'i18n';

export function nameFormatter(
  rootPath: string,
  handleOnSelect: ((account: any) => void) | undefined,
  selectedAccounts: number[],
  cell: any,
  row: any
): any {
  if (handleOnSelect) {
    const isChecked = selectedAccounts.indexOf(row.id) > -1;
    const handleChange = () => handleOnSelect(row);
    return (
      <div className={styles.selectableNameCell}>
        <div className={styles.selectCheckBox}>
          <input
            type='checkbox'
            checked={isChecked}
            onChange={handleChange}
            id={`input${row.id}`}
          />
          <label htmlFor={`input${row.id}`} />
        </div>
        <div>
          <Link to={`${rootPath}/${row.id}`}>{cell}</Link>
          <div className={styles.id}>{'ID: ' + row.id}</div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.nameCell}>
      <Link to={`${rootPath}/${row.id}`}>{cell}</Link>
      <div className={styles.id}>{'ID: ' + row.id}</div>
    </div>
  );
}

export function nameHeaderFormatter(
  handleOnSelectAll: () => void,
  selectedCount: number,
  totalCount: number,
  column: any,
  columnIndex: number,
  { sortElement }
): any {
  const allSelected = selectedCount === totalCount && totalCount > 0;
  const someSelected = selectedCount > 0 && selectedCount < totalCount;
  const handleCheckboxClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <div className={styles.nameHeader}>
      <div onClick={handleCheckboxClick}>
        <input
          type='checkbox'
          checked={allSelected}
          ref={(el) => el && (el.indeterminate = someSelected)}
          onChange={handleOnSelectAll}
          id='selectAllAccounts'
        />
        <label htmlFor='selectAllAccounts' />
      </div>
      {i18n.t(column.text)}
      {sortElement}
    </div>
  );
}

export function sudoNameFormatter(
  handleOnChange,
  cell: any,
  row: any,
  rowIndex,
  state
): any {
  return (
    <div className={styles.sudoNameCell}>
      <div className={styles.selectCheckBox}>
        <input
          type='checkbox'
          checked={state.accountId === row.id}
          onChange={handleOnChange}
          value={row.id}
          id={`input${row.id}`}
        />
        <label htmlFor={`input${row.id}`} />
      </div>
      <div>
        <span>{cell}</span>
        <div className={styles.id}>{'ID: ' + row.id}</div>
      </div>
    </div>
  );
}

export function statusFormatter(cell: any, row: any): any {
  return (
    <Fragment>
      {row.activated ? i18n.t('accounts.active') : i18n.t('accounts.inactive')}
    </Fragment>
  );
}
